import Vue from 'vue';
export default Vue.extend({
  name: 'draggable',

  data: () => ({
    editable: true,
    isDragging: false,
    delayedDragging: false
  }),
  computed: {
    dragOptions(): object {
      return {
        animation: 1,
        group: 'description',
        disabled: !this.editable,
        ghostClass: 'ghost'
      };
    }
  },
  methods: {}
});
